import React, { useContext } from 'react'
import { UserContext } from '../../context'

const FooterPublic = () => {

    const { user } = useContext(UserContext)

    return (
        <footer className="footer-v2">
            <p className='mr-24 '>
                {user.firstname
                    ? `${user.firstname} ${user.lastname}`
                    : ''}
            </p>
            <p className='ml-auto'>
                &copy; 2005-{new Date().getFullYear()}{' '}
            </p>
            <p className='ml-24'>
                <a
                    href="https://realestate.orisha.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    realestate.orisha.com
                </a>
            </p>
            <p className='ml-24'>
                <a
                    href="https://realestate.orisha.com/mentions-legales/"
                    target="_blank"
                    rel="noreferrer"
                    className="policy"
                >
                    Mentions légales
                </a>
            </p>
            <p className='ml-24'>
                <a
                    href="https://realestate.orisha.com/cgv/"
                    target="_blank"
                    rel="noreferrer"
                    className="policy"
                >
                    Conditions générales de ventes
                </a>
            </p>
        </footer>
    )
}

export default FooterPublic
